// extracted by mini-css-extract-plugin
export default {"headerSection":"tall-page-header-module__headerSection___tikHc","headerTitle":"tall-page-header-module__headerTitle____231x"};